import { observer } from 'mobx-react';

const AgentSearchTimeSection = observer(({ title }) => {
  return (
    <div className="agent-search-time-section">
      <div className="agent-search-time-header">
        <span className="agent-search-time-title">{title}</span>
      </div>
    </div>
  );
});

export default AgentSearchTimeSection;